




























import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
import { validate } from "vee-validate";
import { BACKEND_DATETIME_FORMAT } from "@/data/date";
import HasValidation from "@/mixins/HasValidation";
import { ValidationObserver } from "vee-validate";

@Component
export default class DatePicker extends Mixins(HasValidation) {
  public $refs!: {
    datePicked: HTMLFormElement;
    observer: InstanceType<typeof ValidationObserver>;
  };

  @Prop({ required: true })
  public value!: string;

  @Prop({ default: false })
  public focus!: boolean;

  @Prop({ default: "" })
  public fieldVname!: string;

  @Prop({ required: true })
  public fieldVid!: string;

  @Prop({ default: "" })
  public afterDate!: string;

  @Prop({ default: false })
  public disabled!: boolean;

  @Prop({ default: "" })
  public beforeDate!: string;

  @Prop({ default: false })
  public isRequired!: boolean;

  @Prop({ default: true })
  public showErrors!: boolean;

  @Prop({ default: true })
  public showLabel!: boolean;

  public timeStampPicked = "";
  public dateFormat = "DD/MM/YYYY HH:mm";

  public created() {
    this.timeStampPicked = this.value
      ? this.$moment
          .utc(this.value)
          .local()
          .format(this.dateFormat)
      : "";
  }

  public get afterDatePicked() {
    return this.afterDate
      ? this.$moment
          .utc(this.afterDate)
          .local()
          .format(this.dateFormat)
      : "";
  }

  public get beforeDatePicked() {
    return this.beforeDate
      ? this.$moment
          .utc(this.beforeDate)
          .local()
          .format(this.dateFormat)
      : "";
  }

  public get validationRules() {
    return `${this.isRequired ? "required|" : ""}date_format:${
      this.dateFormat
    }${
      this.afterDatePicked
        ? `|after:${this.afterDatePicked},${this.dateFormat}`
        : ""
    }${
      this.beforeDatePicked
        ? `|before:${this.beforeDatePicked},${this.dateFormat}`
        : ""
    }`;
  }

  public async openSetTimestampModal() {
    this.$emit("pickModalOpen", "open");
    const modal = await this.$store.dispatch("ui/open/windowModal", {
      config: {
        component: () =>
          import("@/components/app/global/time/setTimeStampModal.vue"),
        props: {
          timestamp: this.getParsedBack(this.timeStampPicked),
          min: this.afterDatePicked,
          max: this.beforeDatePicked
        },
        width: 480,
        onCancel: () => {
          this.$emit("pickModalOpen", "closed");
        },
        events: {
          success: (newTimeStamp: string) => {
            this.timeStampPicked = newTimeStamp;
            this.$emit("pickModalOpen", "closed");
            modal.close();
          }
        }
      }
    });
  }

  public getParsedBack(timeStamp: string) {
    return timeStamp
      ? this.$moment(timeStamp, this.dateFormat).format(BACKEND_DATETIME_FORMAT)
      : "";
  }

  /**
   * @name onTimeStampPickedChanged
   * @param localDatetime
   * @desc Here we validate the selected timestamp and return in UTC format
   */

  @Watch("timeStampPicked")
  public onTimeStampPickedChanged(localDatetime: string) {
    validate(localDatetime, this.validationRules).then(result => {
      if (result.valid) {
        const localMoment = this.$moment(localDatetime, this.dateFormat);
        const utcMoment = this.$moment(localMoment).utc();
        this.$emit(
          "input",
          localDatetime ? utcMoment.format(BACKEND_DATETIME_FORMAT) : ""
        );
      }
    });
  }
}
